import * as z from "zod";

export const ManagedReturnsTrialSubmissionInputSchema = z.object({
  returnsManagement: z.enum(["3pl", "in-house"]),
  productHandling: z.enum(["fulfill", "consolidate"]),
});

export type ManagedReturnsTrialSubmissionInput = z.infer<
  typeof ManagedReturnsTrialSubmissionInputSchema
>;

export const submitManagedReturnsTrial = {
  name: "submitManagedReturnsTrial" as const,
  input: ManagedReturnsTrialSubmissionInputSchema,
  output: z.object({ submissionId: z.string() }),
};
